module.exports = __webpack_public_path__ + "static/international-day-dc6d9b7a9702a6654c05aa3b0f221dae.jpg";